<template>
  <div>
    <navbar :hasSearch="true" />
    <div id="content">
      <div class="row">
        <div class="col-md-6 pb-3">
          <div class="card h-100">
            <ol class="breadcrumb lighten-4 my-auto">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'landingPage' }">
                  <a class="black-text" href="#">Home</a>
                </router-link>
                <i class="fa fa-angle-right mx-2" aria-hidden="true"></i>
              </li>
              <li class="breadcrumb-item active font-weight-bold">
                Bill Run
                <i class="fa fa-angle-right mx-2" aria-hidden="true"></i>
              </li>
            </ol>
          </div>
        </div>
        <quick-links></quick-links>
      </div>

      <div class="content_body">
        <div class="container-fluid no-pad">
          <div id="signupLogs">
            <!-- <div class="container-fluid no-pad">
                    <div class="d-flex p-1 mb-3 bg-white brs border border-light rounded">
                        <div class="p-2">
                            <h3 class="pl-1">Bill Runs</h3>
                        </div>
                    </div>
            </div>-->
            <div class="container-fluid no-pad">
              <div class="row">
                <div class="col-lg-12">
                  <div class="row">
                    <div class="col-sm-12">
                      <div class="border border-light rounded">
                        <!-- Refine start -->
                        <form @submit.prevent="submit">
                          <div class="col-sm-12 bg-white brs">
                            <div class="row"></div>
                            <div class="row mt-2">
                              <div class="col-md-6 col-xl-4">
                                <h4>Start a new bill run</h4>
                              </div>
                            </div>
                            <div class="row mt-2">
                              <div class="col-12 col-md-4 col-md-4 mb-4">
                                <el-date-picker
                                  class="pr-4"
                                  v-model="date"
                                  format="dd.MM.yyyy"
                                  :picker-options="pickerOptions"
                                  value-format="yyyy-MM-dd"
                                  type="date"
                                  placeholder="Select a date"
                                  required
                                ></el-date-picker>
                              </div>
                              <div class="col-12 col-md-5 col-lg-auto mb-3">
                                <div class="row">
                                  <span
                                    class="col-auto py-2"
                                    v-for="(billingGroup,
                                    index) in billingGroups"
                                    :key="index"
                                  >
                                    <label class="checkbox">
                                      <input
                                        v-model="selectedBillingGroups"
                                        :value="billingGroup.value"
                                        type="checkbox"
                                      />
                                      <span class="default"></span>
                                    </label>
                                    <span class="px-2">{{
                                      billingGroup.name
                                    }}</span>
                                  </span>
                                </div>
                              </div>
                              <div class="col col-lg-auto text-center">
                                <b-button
                                  class="btn btn-hc mb-3 center"
                                  data-toggle="modal"
                                  data-target="#StartBillRun"
                                  :disabled="selectedBillingGroups.length == 0"
                                  >Start Bill Run</b-button
                                >
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                      <!-- Refine end -->
                      <div
                        class="border border-light rounded bg-white brs my-3 pl-3 pr-3"
                      >
                        <div class="row mt-3 mb-3">
                          <div class="col-12">
                            <h4 class="d-inline">Bill Runs</h4>
                            <div class="d-inline ml-2 my-auto">
                              <a @click="refreshBillRunData" href="#">
                                <img
                                  src="@/assets/img/refresh_icon.png"
                                  class="mb-2"
                                  alt="Refesh Icon"
                                />
                              </a>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-6 col-md-4 col-lg-3">
                            <multiselect
                              v-model="billRunStatus"
                              :options="statusOptions"
                              track-by="name"
                              label="name"
                            >
                              <template
                                slot="singleLable"
                                slot-scope="{ option }"
                                >{{ option.name }}</template
                              >
                            </multiselect>
                          </div>
                          <div class="col-sm-6 col-md-4 col-lg-3">
                            <multiselect
                              v-model="filterBy"
                              :options="billingGroups"
                              placeholder="Filter By Billing Group"
                              :searchable="false"
                              :multiple="true"
                              label="name"
                              track-by="name"
                              :close-on-select="false"
                              :clear-on-select="false"
                              :preserve-search="true"
                            >
                              <template slot="singleLable" slot-scope="{option}">{{option.name}}</template>
                            </multiselect>
                          </div>
                          <div class="col-auto m-2">
                            <label class="checkbox">
                              <input
                                type="checkbox"
                                v-model="hideBatchesOfOne"
                                @click="hideBatchesOfOne = !hideBatchesOfOne"
                              />
                              <span class="default"></span>
                            </label>
                            <span class="d-inline pl-2"
                              >Hide Batches of One</span
                            >
                          </div>
                        </div>
                        <div class="table-responsive-lg" v-if="billRuns">
                          <b-table
                            id="bills_table"
                            striped
                            :items="orderedBillRuns"
                            :fields="billRunFields"
                            :per-page="perPage"
                            :current-page="currentPage"
                            :busy="loading"
                          >
                            <template v-slot:table-busy>
                              <b-row align-h="center">
                                <propagate-loader
                                  class="mb-3"
                                  :color="primaryColour"
                                  :size="16"
                                ></propagate-loader>
                              </b-row>
                            </template>
                            <template slot="BillingGroups" slot-scope="data">
                              <span
                                v-if="data.item.hasOwnProperty('BillingGroups')"
                              >
                                <img
                                  v-if="
                                    data.item.BillingGroups.includes('Monthly')
                                  "
                                  src="@/assets/img/gas_icon.png"
                                  class="img-fit_inline pr-1 float-left"
                                  alt="Gas icon"
                                />
                                <img
                                  v-if="
                                    data.item.BillingGroups.includes(
                                      'Electricity'
                                    )
                                  "
                                  src="@/assets/img/electricity_icon.png"
                                  class="img-fit_inline pr-1 float-left"
                                  alt="Electricity icon"
                                />
                              </span>
                            </template>
                            <template slot="BillRunId" slot-scope="data">
                              <span
                                class="d-inline p-2 fwfont pointer"
                                v-clipboard:copy="data.item.BillRunId"
                                v-clipboard:success="onCopy"
                                v-clipboard:error="onError"
                                >{{ guidShortener(data.item.BillRunId) }}</span
                              >
                            </template>
                            <template slot="BillToDate" slot-scope="data">
                              <span v-if="data.item.BillToDate">{{
                                data.item.BillToDate | shortDate()
                              }}</span>
                            </template>
                            <template slot="BillRunStarted" slot-scope="data">
                              <span v-if="data.item.BillRunStarted">{{
                                data.item.BillRunStarted | shortDate()
                              }}</span>
                              <br />
                              <span v-if="data.item.BillRunStarted">{{
                                timeOfRun(data.item.BillRunStarted)
                              }}</span>
                              <span v-else>N/A</span>
                            </template>
                            <template slot="BillRunCompleted" slot-scope="data">
                              <span v-if="data.item.BillRunCompleted">{{
                                data.item.BillRunCompleted | shortDate()
                              }}</span>
                              <br />
                              <span v-if="data.item.BillRunCompleted">{{
                                timeOfRun(data.item.BillRunCompleted)
                              }}</span>
                              <span v-else>N/A</span>
                            </template>
                            <template slot="Status" slot-scope="data">{{
                              wordSplit(data.item.Status)
                            }}</template>
                            <template slot="CustomersOnHold" slot-scope="data">
                              <router-link
                                :to="{ name: 'billRunOH' }"
                                class="bb link"
                                @click.native="rowClicked(data.item)"
                                >{{ data.item.CustomersOnHold }}</router-link
                              >
                            </template>
                            <template slot="logs" slot-scope="data">
                              <a
                                href="#"
                                class="bb link"
                                data-toggle="modal"
                                data-target="#BillRunLogs"
                                @click="rowClicked(data.item)"
                                >View</a
                              >
                            </template>
                          </b-table>
                        </div>

                        <hr />
                        <div class="container-fluid no-pad">
                          <div class="d-flex overflow-auto my-3">
                            <b-pagination
                              class="my-auto d-flex justify-content-center align-items-center mx-auto"
                              v-model="currentPage"
                              :total-rows="orderedBillRuns.length"
                              :per-page="perPage"
                              aria-controls="bills_table"
                              @input="scrollToTop()"
                            >
                              <template v-slot:first-text>
                                <i
                                  class="fas fa-angle-double-left fa-2x pointer"
                                ></i>
                              </template>
                              <template v-slot:prev-text>
                                <i
                                  class="fas fa-chevron-left fa-2x pointer"
                                ></i>
                              </template>
                              <template v-slot:next-text>
                                <i
                                  class="fas fa-chevron-right fa-2x pointer"
                                ></i>
                              </template>
                              <template v-slot:last-text>
                                <i
                                  class="fas fa-angle-double-right fa-2x pointer"
                                ></i>
                              </template>
                            </b-pagination>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- 12 col close -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="modal fade"
        id="StartBillRun"
        tabindex="-1"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-sm" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <div class="col-12 my-auto">
                <span>
                  <a class="close">
                    <i
                      class="far fa-times-circle fa-2x"
                      data-dismiss="modal"
                      id="closeStartBillRun"
                      aria-label="Close"
                    ></i>
                  </a>
                </span>
              </div>
            </div>
            <div class="container-fluid">
              <div class="modal-body">
                <div class="container-fluid">
                  <div class="row text-center mt-3">
                    <div class="col-sm-12">
                      <p class="font-weight-bold">
                        Are you sure you want to start a bill run?
                      </p>
                    </div>
                    <div class="col-sm-12 no-pad">
                      <button
                        type="submit"
                        class="btn btn-hc w-40 mr-2 mb-3"
                        data-dismiss="modal"
                        aria-label="Close"
                        @click="submit"
                      >
                        Yes
                      </button>
                      <button
                        type="submit"
                        class="btn btn-hc w-40 ml-2 mb-3"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        No
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- content close -->
</template>
<script>
import Navbar from "@/components/Navbar.vue";
import QuickLinks from "@/components/QuickLinks.vue";
import moment from "moment";
import Vue from "vue";
import { _ } from "vue-underscore";
import _filters from "@/mixins/filters.js";

export default {
  components: {
    Navbar,
    QuickLinks,
  },
  mixins: [_filters],
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      selectedBillingGroups: [],
      filterBy: [],
      date: moment().format("YYYY-MM-DD"),
      pickerOptions: {
        disabledDate: (date) => {
          return date > moment();
        },
      },
      activeService: {
        serial: 0,
      },
      statusOptions: [
        {
          value: "Preparing",
          name: "Preparing",
        },
        {
          value: "InProgress",
          name: "In Progress",
        },
        {
          value: "Completed",
          name: "Completed",
        },
        {
          value: "Failed",
          name: "Failed",
        },
      ],
      billRunFields: {
        BillingGroups: {
          label: "",
          sortable: false,
          class: "text-center table__col--narrow",
        },
        BillRunId: {
          label: "Bill Run",
          sortable: true,
          class: "text-center",
        },
        BillToDate: {
          label: "Bill To Date",
          class: "text-center",
        },
        BillRunStarted: {
          label: "Started",
          class: "text-center",
        },
        BillRunCompleted: {
          label: "Ended",
          class: "text-center",
        },
        Status: {
          label: "Status",
          class: "text-center",
        },
        CustomersStarted: {
          label: "Started",
          class: "text-center",
        },
        CustomersRemaining: {
          label: "Remaining",
          class: "text-center",
        },
        CustomersSkipped: {
          label: "Skipped",
          class: "text-center",
        },
        CustomersFailed: {
          label: "Failed",
          class: "text-center",
        },
        CustomersSuccessful: {
          label: "Successful",
          class: "text-center",
        },
        CustomersOnHold: {
          label: "Placed On Hold",
          class: "text-center",
        },
        logs: {
          label: "Logs",
          class: "text-center",
        },
      },
    };
  },
  computed: {
    billingGroups() {
      return Vue.config.honeycomb.billingGroups;
    },
    loading() {
      return this.$store.state.finances.loading;
    },
    primaryColour() {
      return Vue.config.honeycomb.theme;
    },
    accessToken() {
      return this.$auth.accessToken;
    },
    xsrfToken() {
      return this.$auth.xsrfToken;
    },
    moneybot() {
      return Vue.config.honeycomb.moneybot.domain;
    },
    results() {
      return this.$store.state.results;
    },
    orderedBillRuns() {
      let hideBatchesOfOne = this.hideBatchesOfOne;
      let orderedBillRuns = _.filter(this.billRuns, function(bill) {
        return hideBatchesOfOne ? bill.CustomersStarted > 1 : bill;
      });

      if (this.filterBy.length > 0) {
        let that = this;
        orderedBillRuns = _.filter(orderedBillRuns, (billRun) => {
          let show = false;
          that.filterBy.forEach((opt) => {
            if (
              billRun.hasOwnProperty("BillingGroups") &&
              billRun.BillingGroups.includes(opt.value)
            )
              show = true;
          });
          return show;
        });
      }

      return _.sortBy(orderedBillRuns, "BillRunStarted").reverse();
    },
    billRuns() {
      return this.$store.state.finances.billRuns;
    },
    billRunStatus: {
      get() {
        return this.$store.state.finances.billRunStatus;
      },
      set(status) {
        this.$store.commit("updateBillRunStatus", status);
        this.currentPage = 1;
        this.$store.dispatch("getBillRuns");
      },
    },
    hideBatchesOfOne: {
      get() {
        return this.$store.state.finances.hideBatchesOfOne;
      },
      set(bool) {
        this.$store.commit("updateHideBatchesOfOne", bool);
      },
    },
  },
  methods: {
    scrollToTop() {
      document.getElementById("bills_table").scrollIntoView();
    },
    guidShortener: function(guid) {
      var foo = guid.slice(0, 8);
      return foo;
    },
    timeOfRun: function(datetime) {
      var lemon = datetime.slice(11, 19);
      return lemon;
    },
    search: function() {
      this.$store.dispatch("search", this.searchId);
    },
    refreshBillRunData() {
      this.$store.dispatch("getBillRuns");
    },
    rowClicked(item) {
      this.$store.dispatch("getBillLogs", item);
      this.$store.dispatch("getBillOH", item);
      this.$store.commit("setBillRun", item);
    },
    submit() {
      if (this.date == "" || this.date == null) {
        this.$snotify.warning(`Please enter a date to bill to.`);
        return false;
      }
      this.$http
        .post(
          "https://" +
            Vue.config.honeycomb.billbotbillrun.domain +
            "/api/v1/Whenever/",
          {
            BillToDate: this.date,
            Customers: [],
            BillingGroups: this.selectedBillingGroups,
          },
          {
            withCredentials: true,
          }
        )
        .then(() => {
          this.$snotify.success(`Success! Bill run created.`);
          // this.$store.dispatch('getBillRuns')
        })
        .catch((error) => {
          // Error
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            if (error.response.data.MoreInformation.length > 0) {
              error.response.data.MoreInformation.forEach((e) => {
                this.$snotify.error(`${e.Error}`, {
                  timeout: 0,
                  closeOnClick: true,
                });
              });
            } else {
              this.$snotify.error(`${error.response.data.UserDescription}`, {
                timeout: 0,
                closeOnClick: true,
              });
            }
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            this.$snotify.error(`No response recieved.`, {
              timeout: 0,
              closeOnClick: true,
            });
          } else {
            // Something happened in setting up the request that triggered an Error
            this.$snotify.error(`${error.message}`, {
              timeout: 0,
              closeOnClick: true,
            });
          }
        });
    },
    onCopy(e, elementId) {
      this.$snotify.success(`${e.text} copied to clipboard.`);
      document.getElementById(elementId).click();
    },
    onError() {
      this.$snotify.error(`Failed to copy text to clipboard.`, {
        timeout: 0,
        closeOnClick: true,
      });
    },
  },
  created() {
    this.$store.dispatch("getBillRuns");
  },
};
</script>
